module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_6000.50ef1463.png";